<template>
  <div class="c-pagination">
    <a
      v-if="showNext"
      @click="handleClick(1)"
      class="c-pagination__link"
      aria-label="next"
    >
      <span aria-hidden="true"
        ><i class="fa fa-angle-right" aria-hidden="true"></i>بعدی</span
      >
    </a>
    <a
      v-if="showPrev"
      @click="handleClick(-1)"
      class="c-pagination__link"
      aria-label="Previous"
    >
      <span aria-hidden="true"
        >قبلی<i class="fa fa-angle-left" aria-hidden="true"></i
      ></span>
    </a>
  </div>
</template>

<script>
export default {
  name: "base-pagination",

  props: {
    showNext: {
      type: Boolean,
      default: false,
    },

    showPrev: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-pagination {
  display: flex;
  align-items: center;
  justify-content: center;

  &__link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 40px;
    cursor: pointer;
    border: 1px solid #eee;
    border-radius: 4px;

    &:first-child {
      margin-left: 16px;

      i {
        margin-left: 8px;
      }
    }

    &:last-child {
      i {
        margin-right: 8px;
      }
    }

    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
